import { string } from "prop-types";
import { Link } from "react-router-dom";

import __ from "web/Layout/Translations";

import classes from "./anchor.scss";

const HelpCenterAnchorMobile = ({ title, url }) => {
  return (
    <Link to={url} className={classes.link}>
      {__(title)}
    </Link>
  );
};

HelpCenterAnchorMobile.propTypes = {
  title: string.isRequired,
  url: string.isRequired,
};

export default HelpCenterAnchorMobile;
